<div class="extended-select-item">
  <div class="extended-select-item__main-title">{{item.modelName}}</div>
  <div *ngIf="item.modelName2" class="extended-select-item__content text-grey">
    <span>{{ item.modelName2 }}</span>
  </div>
</div>
